export function getIp(request) {
    if (process.env && process.env.BEHIND_CLOUDFLARE) {
        return request.headers['cf-connecting-ip'];
    }
    return request.ip;
}
